module.exports = __webpack_public_path__ + "img/sii-icon.839251d4.svg";